import { render, staticRenderFns } from "./manageMasterCodes.vue?vue&type=template&id=2f5cfa16&"
import script from "./manageMasterCodes.vue?vue&type=script&lang=js&"
export * from "./manageMasterCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports